import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import QuestionExamGrade, {
  QuestionExamGradeDTO,
} from '@/models/QuestionExamGrade';
import { BaseFilters } from '@/models/Service';

export interface QuestionExamGradeFilter extends BaseFilters {
  examAreaId?: number;
}

export const listQuestionExamGrades = async (
  params: QuestionExamGradeFilter = {},
) => {
  const { data } = await requester().get<JsonApiResponse<QuestionExamGrade>>(
    'question-exam-grades/',
    { params },
  );
  return data;
};

export const createQuestionExamGrade = async (
  examAreaId: number,
  body: QuestionExamGradeDTO,
) => {
  const { data } = await requester().post<QuestionExamGrade>(
    `exam-areas/${examAreaId}/question-grades/`,
    body,
  );
  return data;
};

export const updateQuestionExamGrade = async (
  examAreaId: number,
  gradeId: number,
  body: Partial<QuestionExamGradeDTO>,
) => {
  const { data } = await requester().patch<QuestionExamGrade>(
    `exam-areas/${examAreaId}/question-grades/${gradeId}/`,
    body,
  );
  return data;
};

export const deleteQuestionExamGrade = async (
  examAreaId: number,
  gradeId: number,
) => {
  await requester().delete<void>(
    `exam-areas/${examAreaId}/question-grades/${gradeId}/`,
  );
};
